import { render, staticRenderFns } from "./ModalFileUploadWarning.vue?vue&type=template&id=74f15ba8&scoped=true"
import script from "./ModalFileUploadWarning.vue?vue&type=script&lang=ts"
export * from "./ModalFileUploadWarning.vue?vue&type=script&lang=ts"
import style0 from "./ModalFileUploadWarning.vue?vue&type=style&index=0&id=74f15ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f15ba8",
  null
  
)

export default component.exports